/* eslint-disable no-param-reassign */
import {
  CLIENTE,
  CLIENTI,
  DEVICES,
  DEVICE,
  ASSISTENZE,
  ADDRESS,
  ASSISTENZA,
  USERS,
  USER,
  TEAMS,
  TEAM,
  SEARCH,
  LASTLOG,
  STORE_LOG,
  DASHBOARD,
  DASHBOARD_TEAM,
  deleteData,
  getBaseApi,
  getData,
  postData,
  putData,
  DASHBOARD_LOW_HOURS
} from './index';

// SEARCH
export const search = (payload) => postData(`${getBaseApi(SEARCH)}`, payload);

//REVERSE GEOCODE
export const getAddress = (lat, lon) => getData(`${getBaseApi(ADDRESS, {lat, lon})}`);

// DASHBOARD
export const getDashboardStatistics = () => getData(`${getBaseApi(DASHBOARD)}`);
export const getDashboardStatisticsTeam = () => getData(`${getBaseApi(DASHBOARD_TEAM)}`);
export const getDashboardStatisticsLowHours = () => getData(`${getBaseApi(DASHBOARD_LOW_HOURS)}`);

// LOG
export const getLogs = () => getData(`${getBaseApi(LASTLOG)}`);

// Cache per de-duplicazione log (evita invii multipli identici in un breve intervallo)
const logCache = new Map();
const LOG_DEDUPLICATION_MS = 1000;

export const storeLog = (message, level = 'info', context = {}) => {
  // Pulizia del messaggio per una de-duplicazione più intelligente (ignora i prefissi di sistema)
  const cleanMessage = message.replace(/^(Global JS Error:|React Error:|Unhandled Promise Rejection:)\s*"?/i, '').replace(/"?\s*$/, '');
  const cacheKey = `${level}-${cleanMessage}`;
  const now = Date.now();

  if (logCache.has(cacheKey) && now - logCache.get(cacheKey) < LOG_DEDUPLICATION_MS) {
    // console.log('Log duplicato ignorato:', cleanMessage);
    return Promise.resolve({ status: 'ignored' });
  }

  logCache.set(cacheKey, now);

  // Pulisce periodicamente la cache (ogni 5 minuti o se troppo grande)
  if (logCache.size > 50) {
    const oldestKey = logCache.keys().next().value;
    logCache.delete(oldestKey);
  }

  const defaultContext = {
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '-',
    url: (typeof window !== 'undefined' && window.location) ? window.location.href : '-',
  };

  const mergedContext = { ...defaultContext, ...context };

  return postData(`${getBaseApi(STORE_LOG)}`, { message, level, context: mergedContext });
};

// DEVICES
export const getDevices = () => getData(`${getBaseApi(DEVICES)}`);
export const getDevicesSelect = () => getData(`${getBaseApi(DEVICES)}/select`);
export const getDevicesSelectValue = (id) => getData(`${getBaseApi(DEVICES)}/select/${id}`);
export const getDevice = (id) => getData(`${getBaseApi(DEVICE)}/${id}`);
export const getDeviceByCode = (code) => getData(`${getBaseApi(DEVICE)}/code/${code}`);
export const insertDevice = (payload) => postData(`${getBaseApi(DEVICE)}`, payload);
export const deleteDevice = (id) => deleteData(`${getBaseApi(DEVICE)}/${id}`);
export const updateDevice = (id, data) => putData(`${getBaseApi(DEVICE)}/${id}`, { ...data });

// USERS
export const getUsers = () => getData(`${getBaseApi(USERS)}`);
export const getUsersSelect = () => getData(`${getBaseApi(USERS)}/select`);
export const getUsersSelectValue = (id) => getData(`${getBaseApi(USERS)}/select/${id}`);
export const insertUser = (payload) => postData(`${getBaseApi(USER)}`, payload);
export const deleteUser = (id) => deleteData(`${getBaseApi(USER)}/${id}`);
export const updateUser = (id, data) => putData(`${getBaseApi(USER)}/${id}`, { ...data }, { timeout: 10000 });

// TEAMS
export const getTeams = () => getData(`${getBaseApi(TEAMS)}`);
export const getTeamSelect = () => getData(`${getBaseApi(TEAMS)}/select`);
export const getTeamSelectValue = (id) => getData(`${getBaseApi(TEAMS)}/select/${id}`);
export const insertTeam = (payload) => postData(`${getBaseApi(TEAM)}`, payload);
export const deleteTeam = (id) => deleteData(`${getBaseApi(TEAM)}/${id}`);
export const updateTeam = (id, data) => putData(`${getBaseApi(TEAM)}/${id}`, { ...data }, { timeout: 10000 });

// clienti
export const getClients = () => getData(`${getBaseApi(CLIENTI)}`);
export const getClientsSelect = () => getData(`${getBaseApi(CLIENTI)}/select`);
export const getClientsSelectValue = (id) => getData(`${getBaseApi(CLIENTI)}/select/${id}`);
export const insertClient = (payload) => postData(`${getBaseApi(CLIENTE)}`, payload);
export const deleteClient = (id) => deleteData(`${getBaseApi(CLIENTE)}/${id}`);
export const updateClient = (id, data) => putData(`${getBaseApi(CLIENTE)}/${id}`, { ...data });

// assistence (richieste di assistenza)

export const getAssistance = (id) => getData(`${getBaseApi(ASSISTENZA)}/${id}`);
export const getAssistences = () => getData(`${getBaseApi(ASSISTENZE)}`);
export const getAssistancesLast = () => getData(`${getBaseApi(ASSISTENZE)}/last`);
export const getAssistencesSelect = () => getData(`${getBaseApi(ASSISTENZE)}/select`);
export const getAssistencesSelectValue = (id) => getData(`${getBaseApi(ASSISTENZE)}/select/${id}`);
export const insertAssistance = (payload) => postData(`${getBaseApi(ASSISTENZA)}`, payload);
export const deleteAssistance = (id) => deleteData(`${getBaseApi(ASSISTENZA)}/${id}`);
export const updateAssistance = (id, data) => putData(`${getBaseApi(ASSISTENZA)}/${id}`, { ...data });
